import './cell.scss';

interface IProps {
    children: React.ReactNode;
    disabled?: boolean;
}

const Cell: React.FC<IProps> = ({ children, disabled = false }) => {
    return <div className={`inactive-rma-cancel-settings-list-column ${disabled && 'disabled'}`}>{children}</div>;
}

export default Cell;